import { Progress, Typography, Row, Col } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';
import { colors } from '../../../shared/styles/baseStyle';
import styles from './styles';
import HomeCard from '../HomeCard';

export default function KilometresUsage() {
  const { data } = useQuery('getContractInfo');
  const { Text } = Typography;

  const percent = (
    (data.kilometers / data.currentPackageDuration) *
    100
  ).toFixed(1);

  return (
    <HomeCard title="Χιλιόμετρα που έχεις διανύσει">
      <Progress percent={percent} strokeColor={colors.anytimeViolet} />
      <Row justify="space-between" style={styles.limitLabelsRow}>
        <Col>
          <Text type="secondary">0 χλμ</Text>
        </Col>
        <Col>
          <Text style={styles.textPercent}>{data.kilometers} χλμ</Text>
        </Col>
        <Col>
          <Text type="secondary">{data.currentPackageDuration} χλμ</Text>
        </Col>
      </Row>
      <Row align="middle" style={styles.rowInfo}>
        <Col flex="none">
          <InfoCircleOutlined style={styles.infoIcon} />
        </Col>
        <Col flex="auto">
          <Text>
            Έχεις καταναλώσει {data.kilometers} από τα συνολικά σου χιλιόμετρα.
          </Text>
        </Col>
      </Row>
    </HomeCard>
  );
}
